import { Button } from '@heroui/react';
import {
  Heading, Image as ImageIcon, List, Minus, MousePointerClick, MoveVertical, Sparkles, Text, Type,
} from 'lucide-react';
import React, { FC } from 'react';

import { BLOCK_LABELS } from '../model/factories';
import type { EmailBlockKind } from '../model/types';

const ICONS: Record<EmailBlockKind, FC<{ className?: string }>> = {
  logo: Sparkles,
  heading: Heading,
  text: Text,
  button: MousePointerClick,
  image: ImageIcon,
  list: List,
  divider: Minus,
  spacer: MoveVertical,
  footer: Type,
};

const ORDER: EmailBlockKind[] = [
  'logo', 'heading', 'text', 'button', 'image', 'list', 'divider', 'spacer', 'footer',
];

interface BlockPaletteProps {
  onAdd: (kind: EmailBlockKind) => void;
}

/** Klocki, z których składa się wiadomość. Każdy dodaje się na koniec zaznaczonej sekcji. */
export const BlockPalette: FC<BlockPaletteProps> = ({ onAdd }) => (
  <div className="flex flex-col gap-2">
    <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">Dodaj blok</p>
    <div className="grid grid-cols-2 gap-2">
      {ORDER.map((kind) => {
        const Icon = ICONS[kind];
        return (
          <Button
            key={kind}
            size="sm"
            variant="bordered"
            className="justify-start"
            startContent={<Icon className="h-4 w-4" />}
            onPress={() => onAdd(kind)}
          >
            {BLOCK_LABELS[kind]}
          </Button>
        );
      })}
    </div>
  </div>
);
